import React, { useContext, useState, useEffect } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as actions from '../actions/actions';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/styles";
import DialogContent from '@material-ui/core/DialogContent';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ChipInput from 'material-ui-chip-input';
import DividerLabel from './DividerLabel';


const useStyles = makeStyles(() => ({
  popupButton: {
    justifyContent: "flex-end",
    borderTop: "1px solid #dddddd",
  },
  border: {
    borderStyle: "solid",
    height: "250px",
    borderRadius: "5px",
    borderColor: "#e6e6e6"
  },
  title: {
    padding: "10px 17px",
    borderBottom: "1px solid #dddddd",
  },
  contentData: {
    paddingBottom: "20px",
  },
  content: {
    padding: "10px 16px"
  },
  text_filed_container: {
    width: '100%',
    borderStyle: "solid",
    height: "150px",
    borderRadius: "5px",
    borderColor: "#e6e6e6"
  },
  chipHint: {
    fontSize: "0.75rem",
    color: "#1982DD",
    marginTop: "4px",
  },
  borderColor: {
    width: "100%",
    "& .MuiInput-underline:before": {
      borderBottom: "0px"

    },
    "& .MuiInput-underline:after": {
      borderBottom: "0px"

    },
    "& .MuiInput-underline:not(.Mui-disabled):before": {
      borderBottom: "0px"
    },
  }
}));

export default function AutoExcludeSourcesDialog() {
  const state = useContext(AppContext);
  const s = state.strings;
  const classes = useStyles(state);
  const dispatch = useContext(DispatchContext);
  const [chipsData, setChipsData] = useState([]);
  const [useWhiteList, setUseWhiteList] = useState(false);
  const [excludeLibraryCopies, setExcludeLibraryCopies] = useState(false);
  const [excludeWebCopies, setExcludeWebCopies] = useState(false);

  useEffect(() => {
    setChipsData(state.newCheckSettings.excludeUrlPatterns);
    setUseWhiteList(state.newCheckSettings.excludeByWhitelist);
    setExcludeLibraryCopies(state.newCheckSettings.excludeLibraryCopies);
    setExcludeWebCopies(state.newCheckSettings.excludeWebCopies);
  }, []);

  const handleSubmit = () => {
    dispatch(actions.setNewCheckSettings({ excludeByWhitelist: useWhiteList, excludeLibraryCopies: excludeLibraryCopies, excludeWebCopies: excludeWebCopies, excludeUrlPatterns: chipsData }));
    closeDialogBox();
  }

  const addChip = (chip, index) => {
    setChipsData([...chipsData, chip]);
  }

  const handleUseWhitelistChecked = (checked) => {
    setUseWhiteList(checked);
  }

  const deleteChip = (chip) => {
    const chips = chipsData.filter(item => item !== chip)
    setChipsData(chips)
  }

  const closeDialogBox = () => {
    dispatch(actions.setUI({ autoExcludeSourcesDialogOpen: false }));
  }

  return (
    <Dialog maxWidth="sm" disableBackdropClick={false} open={state.ui.autoExcludeSourcesDialogOpen}>
      <DialogTitle className={classes.title}>
        {s.autoExcludeSources}
      </DialogTitle>
      <DialogContent className={classes.content}>
        <div className={classes.contentData}>
          {s.excludeSourceDialogBoxData}
        </div>
        <ChipInput style={{width: "100%"}} value={chipsData} onDelete={(chip) => deleteChip(chip)} placeholder={s.newCheck.tagsPlaceholder} onAdd={(chip, index) => addChip(chip, index)} />
        <Typography className={classes.chipHint}>{s.patternInputHint}</Typography>
        <DividerLabel label={s.exclusionOptions} />
        <div className={classes.checkboxPadding}>
          <div>
            <FormGroup>
              <FormControlLabel
                control={<Switch checked={useWhiteList} onChange={e => handleUseWhitelistChecked(e.target.checked)} />}
                label={s.useWhiteList} />
              {/* Temporarily disabled for intermediate rollout:
              <FormControlLabel
                control={<Switch checked={excludeLibraryCopies} onChange={e => setExcludeLibraryCopies(e.target.checked)} />}
                label={s.excludeLibraryCopies} />
              <FormControlLabel
                control={<Switch checked={excludeWebCopies} onChange={e => setExcludeWebCopies(e.target.checked)} />}
                label={s.excludeWebCopies} />
              */}
            </FormGroup>
          </div>
        </div>
      </DialogContent>
      <DialogActions className={classes.popupButton} >
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          <span >{s.ok}</span>
        </Button>
        <Button variant="contained" color="primary" onClick={closeDialogBox}>
          <span > {s.cancel} </span>
        </Button>
      </DialogActions>
    </Dialog>
  )
}
